export const BASEURL = process.env.REACT_APP_STATUS_PAGE_URL + "/api/v2";
export const TIME_REQUEST = 60 * 1000 * 5;
export const WIDGET_KEY = ["statusPage"];
